import { profileColors } from 'fitbeat.models';
import { createSelector } from 'reselect';
import { IAppStore } from '../HomeWorkouts';

const getFamilyMembers = (state: IAppStore) => {
  return state.familyMembers.data.familyMembers;
};

const getPendingInvites = (state: IAppStore) => {
  return state.familyMembers.data.pendingInvites;
};

const getSwitchMemberScreenLoading = (state: IAppStore) => {
  return state.familyMembers.view.isSwitchMemberScreenLoading;
};

const getInviteMemberButtonLoading = (state: IAppStore) => {
  return state.familyMembers.view.isInviteMemberButtonLoading;
};

const getIsSwitchingToUser = (state: IAppStore) => {
  return state.familyMembers.data.familyMembers.some((familyMember) => familyMember.isSwoppingToUser);
};

const getActiveFamilyMember = (state: IAppStore) => {
  return state.familyMembers.data.familyMembers.find((familyMember) => familyMember.isCurrentLoggedInUser);
};

const getUserIsContinuingFromSignoutSelector = (state: IAppStore) => {
  return state.familyMembers.view.userIsContinuingFromSignout;
};

const getUserJoinedFamilyPlanSuccessfullySelector = (state: IAppStore) => {
  return state.familyMembers.view.successfullyJoinedFamilyPlan;
};

const getIsAcceptingInvitaionSelector = (state: IAppStore) => {
  return state.familyMembers.view.isAcceptingInvitation;
};

const getJoinedFamilyPlanInformationSelectorSelector = (state: IAppStore) => {
  return state.familyMembers.view.joinedFamilyPlanInformation;
};

const getInviteFamilyPlanMemberErrorSelector = (state: IAppStore) => {
  return state.familyMembers.view.inviteFamilyMemberError;
};

const getCancelPendingInviteErrorSelector = (state: IAppStore) => {
  return state.familyMembers.view.cancelPendingInviteError;
}

const getIsProfileColorChangeLoading = (state: IAppStore) => {
  return state.familyMembers.view.isProfileColorChangeLoading;
};

const getRemoveFamilyPlanMemberErrorSelector = (state: IAppStore) => {
  return state.familyMembers.view.removeFamilyPlanMemberError;
}

const getIsLeavingFamilyPlanSelector = (state: IAppStore) => {
  return state.familyMembers.view.isLeavingFamilyPlan;
}

const getIsProfilePinChangeLoading = (state: IAppStore) => {
  return state.familyMembers.view.isProfilePinChangeLoading;
};

const getIsManagingMembersSelector = (state: IAppStore) => {
  return state.familyMembers.view.isManagingMembers;
};

const getIsSwitchingMemberFailure =  (state: IAppStore) => {
  return state.familyMembers.view.showSwitchingMemberFaliure;
};

const getPinAttempt =  (state: IAppStore) => {
  return state.familyMembers.view.pinAttempt;
};

export const familyMembersSelector = createSelector(
  [getFamilyMembers],
  (familyMembers) => {
    return familyMembers;
  },
);

export const pendingInvitesSelector = createSelector(
  [getPendingInvites],
  (pendingInvites) => {
    return pendingInvites;
  },
)

export const switchMemberScreenLoadingSelector = createSelector(
  [getSwitchMemberScreenLoading],
  (isSwitchMemberScreenLoading) => {
    return isSwitchMemberScreenLoading;
  },
);

export const InviteMemberButtonLoadingSelector = createSelector(
  [getInviteMemberButtonLoading],
  (isInviteMemberButtonLoading) => {
    return isInviteMemberButtonLoading;
  },
);

export const isSwitchingToUserSelector = createSelector(
  [getIsSwitchingToUser],
  (isSwoppingToUser) => {
    return isSwoppingToUser;
  },
);

export const activeFamilyMemberSelector = createSelector(
  [getActiveFamilyMember],
  (activeFamilyMember) => {
    return activeFamilyMember;
  },
);

export const userIsContinuingFromSignoutSelector = createSelector(
  [getUserIsContinuingFromSignoutSelector],
  (userIsContinuingFromSignout) => {
    return userIsContinuingFromSignout;
  },
);

export const userJoinedFamilyPlanSuccessfullySelector = createSelector(
  [getUserJoinedFamilyPlanSuccessfullySelector],
  (userJoinedFamilyPlan) => {
    return userJoinedFamilyPlan;
  },
);

export const isAcceptingInvitationSelector = createSelector(
  [getIsAcceptingInvitaionSelector],
  (isAcceptingInvitaion) => {
    return isAcceptingInvitaion;
  },
);

export const joinedFamilyPlanInformationSelector = createSelector(
  [getJoinedFamilyPlanInformationSelectorSelector],
  (isAcceptingInvitaion) => {
    return isAcceptingInvitaion;
  },
);

export const inviteFamilyPlanMemberErrorSelector = createSelector(
  [getInviteFamilyPlanMemberErrorSelector],
  (inviteFamilyPlanMemberError) => {
    return inviteFamilyPlanMemberError;
  },
);

export const cancelPendingInviteErrorSelector = createSelector(
  [getCancelPendingInviteErrorSelector],
  (getCancelPendingInviteError) => {
    return getCancelPendingInviteError;
  },
);

export const isProfileColorChangeLoadingSelector = createSelector(
  [getIsProfileColorChangeLoading],
  (isProfileColorChangeLoading) => {
    return isProfileColorChangeLoading;
  },
);

export const removeFamilyPlanMemberErrorSelector = createSelector(
  [getRemoveFamilyPlanMemberErrorSelector],
  (removeFamilyPlanMemberError) => {
    return removeFamilyPlanMemberError;
  },
)

export const isLeavingFamilyPlanSelector = createSelector(
  [getIsLeavingFamilyPlanSelector],
  (isLeavingFamilyPlan) => {
    return isLeavingFamilyPlan;
  },
)
export const isProfilePinChangeLoadingSelector = createSelector(
  [getIsProfilePinChangeLoading],
  (isProfilePinChangeLoading) => {
    return isProfilePinChangeLoading;
  },
);

export const isManagingMembersSelector = createSelector(
  [getIsManagingMembersSelector],
  (isManagingMembers) => {
    return isManagingMembers;
  },
);

export const familyMemberProfileColorSelector = createSelector(
  [
    activeFamilyMemberSelector,
  ],
  (familyMember) => {
    return (familyMember && familyMember.familyPlanSettings && familyMember.familyPlanSettings.profileColor) ?
    familyMember.familyPlanSettings.profileColor : profileColors[0];
  },
);

export const switchMemberFailureSelector = createSelector(
  [getIsSwitchingMemberFailure],
  (isSwitchingMemberFailure) => isSwitchingMemberFailure,
);

export const pinAttemptSelector = createSelector(
  [getPinAttempt],
  (pinAttempt) => pinAttempt,
);

export const memberHasPinSelector = createSelector(
  [activeFamilyMemberSelector],
  (member) => {
    return member?.familyPlanSettings && member.familyPlanSettings.hasPin;
  },
);
